export const successNotificationTimeout = 8000;
export const infoNotificationTimeout = 8000;
